<template>
    <section class="main-section main-section--practice-areas">
        <v-container class="container--large">
            <v-row>
                <v-col cols="12" lg="3" class="mb-10px mb-lg-0">
                    <div class="pt-lg-28px">
                        <h2 class="tit tit--lg tit--point white--text line-height-11">
                            <span v-html="lang === 'ko' ? '업무분야' : 'Practice <br />Areas'" />
                            <span class="ko tit--point__circle" data-aos="zoom-in" />
                            <!-- <span class="tit--point__circle" :class="{ 'ko' : lang === 'ko' }" data-aos="zoom-in" /> -->
                        </h2>
                    </div>
                </v-col>
                <v-col cols="12" lg="9">
                    <v-row class="link-cards row--lg">
                        <v-col v-for="(item, index) in currentItems" :key="index" cols="12" md="6">
                            <main-link-card :to="item.to" :tit="item.title" :icon="item.icon" data-aos="fade-up" :data-aos-delay="index * 100">
                                {{ item.text }}
                            </main-link-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import MainLinkCard from "./main-link-card.vue";

export default {
    components: {
        MainLinkCard,
    },
    props: {
        lang: { type: String, default: "ko" },
    },
    data() {
        return {
            ko: [
                {
                    title: "기업법무",
                    text: "수많은 업무 사례를 통해 축적한 전문성과 비즈니스에 대한 깊은 이해를 바탕으로, 세이지는 실질적인 해결책과 명확한 조언을 원하는 기업 고객에게 최적의 파트너가 되어 드릴 것입니다.",
                    icon: "/images/main/s2-icon1.svg",
                    to: "/practice/corporate",
                },
                {
                    title: "소송 / 분쟁",
                    text: "세이지는 가장 복잡하고 도전적인 분쟁에서도 국내 소송과 국제 분쟁을 아우르며, 고객에게 최상의 법률 전략과 결과를 제공하는 전문성과 수행 역량을 갖춘 로펌입니다.",
                    icon: "/images/main/s2-icon2.svg",
                    to: "/practice/dispute",
                },
            ],
            en: [
                {
                    title: "Corporate Advisory",
                    text: "Drawing on our extensive experience and deep understanding of business, SAGE is the ideal partner for companies seeking practical solutions and clear guidance.",
                    icon: "/images/main/s2-icon1.svg",
                    to: "/en/practice/corporate",
                },
                {
                    title: "Dispute Resolution",
                    text: "SAGE is known for its expertise and capability to deliver the best legal strategies and outcomes for its clients, in both domestic litigation and international disputes.",
                    icon: "/images/main/s2-icon1.svg",
                    to: "/en/practice/dispute",
                },
            ],
        };
    },
    computed: {
        currentItems() {
            return this.lang === "ko" ? this.ko : this.en;
        },
    },
};
</script>

<style lang="scss" scoped>
.main-section {
    &--practice-areas {
        background: url(/images/main/practice-areas/background.jpg) no-repeat center / cover;
    }
}
.link-cards {
    > [class*="col"] {
        > .main-link-card {
            border-bottom: 1px solid #fff;
        }
        &:first-child {
            > .main-link-card {
                border-top: 1px solid #fff;
            }
        }
    }
}
@media (min-width: 768px) {
    .link-cards {
        > [class*="col"] {
            > .main-link-card {
                border-top: 1px solid #fff;
            }
        }
    }
}
</style>